import {
  GetVehicleTypeQueryErrorType,
  GetVehicleTypeQueryParamsType,
} from '@/common/queries/getVehicleType/getVehicleTypeQuery.type';
import { getVehicleType } from '@/common/queries/getVehicleType/getVehicleTypeQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getVehicleTypeQueryOption = (params: GetVehicleTypeQueryParamsType) => {
  const { enabled = true } = params;
  return queryOptions({
    queryKey: ['getVehicleType', params],
    queryFn: () => getVehicleType(params),
    enabled: enabled,
    select: (data) => data[0],
    meta: {
      onError: (err: GetVehicleTypeQueryErrorType) => {
        params.onError?.(err);
      },
      onSuccess: () => {
        params.onSuccess;
      },
    },
  });
};

export default getVehicleTypeQueryOption;
